module.exports = __webpack_public_path__ + "static/videoPR_2-5fd9c46eac4f5d0f28f8018b04abf368.mp4";